var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 88,
    viewBox: "0 0 75 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 72,
    height: 84,
    rx: 6.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3444 70.292C33.4564 70.292 29.8324 69.62 26.4724 68.276C23.1604 66.884 20.3764 64.94 18.1204 62.444L24.4564 56.54C26.3764 58.604 28.2724 60.044 30.1444 60.86C32.0644 61.628 34.4164 62.012 37.2004 62.012C39.2164 62.012 40.9684 61.724 42.4564 61.148C43.9924 60.524 45.1684 59.66 45.9844 58.556C46.8484 57.452 47.2804 56.18 47.2804 54.74C47.2804 53.396 46.9444 52.244 46.2724 51.284C45.6004 50.324 44.6884 49.58 43.5364 49.052C42.3844 48.476 41.0164 48.188 39.4324 48.188H33.0964V40.412H38.5684C40.8244 40.412 42.6004 39.836 43.8964 38.684C45.1924 37.484 45.8404 35.852 45.8404 33.788C45.8404 32.444 45.4564 31.244 44.6884 30.188C43.9204 29.084 42.8644 28.22 41.5204 27.596C40.2244 26.972 38.7364 26.66 37.0564 26.66C34.5604 26.66 32.4004 27.092 30.5764 27.956C28.8004 28.82 26.9284 30.356 24.9604 32.564L18.5524 26.66C20.9044 24.02 23.7124 21.98 26.9764 20.54C30.2884 19.052 33.7684 18.308 37.4164 18.308C40.9204 18.308 44.0164 18.932 46.7044 20.18C49.3924 21.38 51.5044 23.06 53.0404 25.22C54.5764 27.38 55.3444 29.852 55.3444 32.636C55.3444 35.324 54.4564 37.724 52.6804 39.836C50.9044 41.9 48.6004 43.34 45.7684 44.156C49.1284 44.828 51.7924 46.172 53.7604 48.188C55.7764 50.204 56.7844 52.628 56.7844 55.46C56.7844 58.292 55.9444 60.836 54.2644 63.092C52.5844 65.348 50.2804 67.124 47.3524 68.42C44.4724 69.668 41.1364 70.292 37.3444 70.292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.6240e9ab53ad2d1d8420cdc35b83f3ab.svg";
export { ForwardRef as ReactComponent };